import {
    BooleanField, Create, Datagrid, Edit, Form, ImageField, List,
    NullableBooleanInput, NumberField, NumberInput, required, SimpleForm, TextField, TextInput,
    Toolbar,
    useRecordContext
} from "react-admin";


import { DurationInput, ImageInputSafe } from "@/src/components";
import { LANGUAGES } from "@/src/services";
import { Card, CardContent, Divider, Paper, Typography } from "@mui/material";

export const MoodList = () => (
    <List
        perPage={25} sort={{ field: 'order', order: 'ASC' }}
        exporter={false}
    >
        <Datagrid rowClick="edit"

        >
            <TextField source="id" />
            <BooleanField source="enabled" />
            <NumberField source="durationSec" label={<s>duration sec</s>} />
            <TextField source="duration" />

            <NumberField source="order" />

            <ImageField source="imageUrl" label={"Image"}
                sx={{ '& .RaImageField-image': { height: "24px", objectFit: "contain" } }}

            />
        </Datagrid>
    </List>
);


const MoodFormConent = () => {
    const record = useRecordContext();

    return (
        <Card>
            <CardContent>
                <TextInput label={"Id"} source="id" readOnly={!!record} fullWidth validate={required()} />
                <NullableBooleanInput source="enabled" helperText={"Default is enabled"} />

                <DurationInput source="duration" validate={required()} />
                <NumberInput source="order" validate={required()} />
                <ImageInputSafe source="imageUrl"
                    accept={{ 'image/*': ['.jpeg', '.jpg', '.png', '.svg'], }} multiple={false} />
                <TextInput source="imageUrl" fullWidth />


                <Divider textAlign="left">Texts</Divider>
                {LANGUAGES.map(({ id, name }) => <TextInput key={id} label={name} source={`text.${id}`} fullWidth />)}

            </CardContent>
            <Toolbar />
        </Card>)
}

export const MoodEdit = () => (
    <Edit>
        <Form>
            <MoodFormConent />
        </Form>
    </Edit>

);

export const MoodCreate = () => (
    <Create>
        <Form>
            <MoodFormConent />
        </Form>
    </Create>

);